import type { InputHTMLAttributes, LabelHTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

export function Label({ className, ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
    return <label {...props} className={cn("text-sm font-medium text-ink", className)} />;
}

export function Input({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
    return (
        <input
            {...props}
            className={cn(
                "h-10 w-full rounded-lg border border-line bg-surface px-3 text-sm text-ink",
                "placeholder:text-ink-muted/60 disabled:bg-surface-muted disabled:text-ink-muted",
                "focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20",
                className,
            )}
        />
    );
}

export function Field({
    label,
    htmlFor,
    hint,
    children,
}: {
    label: string;
    htmlFor: string;
    hint?: ReactNode;
    children: ReactNode;
}) {
    return (
        <div className="space-y-1.5">
            <Label htmlFor={htmlFor}>{label}</Label>
            {children}
            {hint && <p className="text-xs text-ink-muted">{hint}</p>}
        </div>
    );
}
